import { useGetPurchaseReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function PurchaseReport() {
  const { t } = useTranslation();

  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      usePivotQuery={useGetPurchaseReports}
      title={t('common:purchase_report')}
      completeName={['agent', 'type']}
      defaultFilters={defaultFilters}
    />
  );
}
